import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-two-lesson-one-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitTwoLessonSixGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 2, Lesson 6 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 6: Exploring Agency Options";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
